// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__32sWy","title":"InfoRow_title__3k0sg"};